import { Auth } from 'aws-amplify'
import AWS, { CognitoIdentityServiceProvider } from 'aws-sdk'
import awsExport from '../aws-exports.js'
import navigation from '../nav'
import { markets, simplifiedMarkets } from 'admin-console-common'

const USER_GRANTS_VIEW = 'USER_GRANTS_VIEW'

export async function getListUsers() {
  let cognito = await _getCognito(),
    params = {
      UserPoolId: awsExport.aws_user_pools_id,
    }

  let users = await _getAllUsers(params, cognito, [], {})
  return users
}

async function _getAllUsers(params, cognito, users, datas) {
  if (users?.length === 0) {
    datas = await new Promise(resolve => {
      cognito.listUsers(params, (err, data) => resolve(data))
    })
    users = datas.Users
  }

  if (datas?.PaginationToken) {
    params.PaginationToken = datas.PaginationToken
    datas = await new Promise(resolve => {
      cognito.listUsers(params, (err, data) => resolve(data))
    })
    users = users.concat(datas.Users)
    users = await _getAllUsers(params, cognito, users, datas)
  }

  return users
}

export async function getListNewUsers() {
  let cognito = await _getCognito(),
    params = {
      UserPoolId: awsExport.aws_user_pools_id,
    },
    users = []

  let response = await new Promise(resolve => {
    cognito.listUsers(params, (err, data) => resolve(data))
  })

  for (let key in response?.Users) {
    if (response?.Users[key]?.UserStatus === 'UNCONFIRMED') {
      users.push(response.Users[key])
    }
  }

  return users
}

export async function updateStatusUser(user, status) {
  let cognito = await _getCognito(),
    params = {
      Username: user.Username,
      UserPoolId: awsExport.aws_user_pools_id,
      UserAttributes: [
        {
          Name: 'custom:isValidated',
          Value: status === 'confirmed' ? '1' : '0',
        },
      ],
    }

  await new Promise(resolve => {
    cognito.adminUpdateUserAttributes(params, (err, data) => resolve(data))
  })
}

export async function updateRoleUser(user, data) {
  let cognito = await _getCognito(),
    params = {
      Username: user,
      UserPoolId: awsExport.aws_user_pools_id,
      UserAttributes: [],
    }

  for (let key in data) {
    let attributes = {}
    attributes.Name = data[key].name
    attributes.Value = data[key].value
    params.UserAttributes.push(attributes)
  }

  await new Promise(resolve => {
    cognito.adminUpdateUserAttributes(params, (err, data) => resolve(data))
  })
}

export function filteredUsersByAdmin(users, authenticatedUser) {
  const adminType = authenticatedUser.attributes['custom:entity'].split('_')
  const market = authenticatedUser.attributes['custom:market']
  let usersFiltered = []
  for (let user of users) {
    if (
      getAttrUser('custom:entity', user) === adminType[1] &&
      getAttrUser('custom:market', user) === market
    ) {
      usersFiltered.push(user)
    }
  }
  return usersFiltered
}

export function getUsersFilteredAndSorted(users, filter, search) {
  if (filter && filter?.value !== '') {
    users = users.filter(
      user => getAttrUser('custom:entity', user) === filter.value
    )
  }

  if (search !== '') {
    users = users.filter(
      user =>
        user?.Username?.includes(search) ||
        getAttrUser('email', user).includes(search)
    )
  }

  users.sort((a, b) => {
    if (a?.UserCreateDate < b?.UserCreateDate) {
      return 1
    }
    if (a?.UserCreateDate > b?.UserCreateDate) {
      return -1
    }
    return 0
  })

  return users
}

export function getAttrUser(attribute, user) {
  let attr = '',
    attrs = user.Attributes

  if (!attrs) {
    attrs = user.attributes
  }

  for (let key in attrs) {
    if (attrs[key]?.Name === attribute) {
      attr = attrs[key].Value
    }
  }

  return attr
}

export const dashboardsAccess = (user, dashboard) => {
  if (!user) return false
  const currentRole = dashboard.access.split(' ')
  if (user?.attributes['custom:dashboard']) {
    return (
      currentRole.includes(user.attributes['custom:entity']) &&
      user.attributes['custom:dashboard'].includes(dashboard.value)
    )
  }
  return currentRole.includes(user?.attributes['custom:entity'])
}

export function haveAccess(page, entity) {
  let haveAccess = false
  for (let key in navigation) {
    let split = navigation[key].access.split(' ')
    for (let key2 in split) {
      if (navigation[key]?.name === page && split[key2] === entity) {
        return true
      }
    }
  }

  return haveAccess
}

const userIsValidated = user =>
  user?.signInUserSession?.idToken?.payload['custom:isValidated'] === '1' ||
  user?.attributes['custom:isValidated'] === '1'

export function checkAccess(user, page, history) {
  if (userIsValidated(user)) {
    if (!haveAccess(page, user?.attributes['custom:entity'])) {
      history.push('/login')
    }
  } else {
    history.push('/login')
  }
}

export function isSimplified(market) {
  let isSimplified = false
  for (let item of simplifiedMarkets) {
    if (item?.value === market) isSimplified = true
  }
  return isSimplified
}

export function getLabelMarket(market) {
  const marketsfiltered = markets.filter(item => item?.value === market)
  return marketsfiltered[0] && marketsfiltered[0].label
}

async function _getCognito() {
  let credential = await Auth.currentCredentials(),
    AWSconfig = new AWS.Config({
      apiVersion: '2016-04-18',
      credentials: credential,
      region: awsExport.aws_cognito_region,
    }),
    cognito = new CognitoIdentityServiceProvider(AWSconfig)

  return cognito
}

export function getMarketsByCountry() {
  let _markets = []
  for (let market of markets) {
    if (!isInArray(_markets, market)) {
      _markets.push(market)
    }
  }
  return _markets
}

function isInArray(array, value) {
  for (let item of array) {
    if (item?.label === value?.label) return true
  }
  return false
}

export const hasSettingsView = user =>
  user?.roles?.[0]?.permissions?.some(
    permission => permission?.permissionCode === USER_GRANTS_VIEW
  )
